// frontend/src/components/common/Field.jsx
// Shared label / hint / error wrapper used by Input, TextArea and Select.
import "./ui.css";

export default function Field({ id, label, hint, error, required, className = "", children }) {
  return (
    <div className={`field${error ? " field--error" : ""} ${className}`.trim()}>
      {label && (
        <label htmlFor={id} className="field__label">
          {label}
          {required && <span className="field__req" aria-hidden="true"> *</span>}
        </label>
      )}
      {children}
      {error ? (
        <span id={`${id}-error`} className="field__error" role="alert">{error}</span>
      ) : hint ? (
        <span id={`${id}-hint`} className="field__hint">{hint}</span>
      ) : null}
    </div>
  );
}
